// Select ALL marquee content elements
const marqueeContents = document.querySelectorAll(".marquee-content");

function setupMarquee() {
  marqueeContents.forEach((marqueeContent) => {
    const content = marqueeContent.querySelector(".marquee-text").innerHTML;
    marqueeContent.innerHTML =
      `<span class="marquee-text">${content}</span>`.repeat(30);
  });
}

window.onload = setupMarquee;
